// components/Dashboard.jsx
import React, { useState } from 'react';
import {
    Home, Plane, FileText, CreditCard,
    CalendarCheck, MessageSquare, Settings,
    Hotel, Package, HelpCircle, Shield,MoveLeft
} from 'lucide-react';
import Sidebar from './dashboardcomponent/SideBar';
import MobileNavigation from './dashboardcomponent/MobileNavigation';
import DashboardHeader from './dashboardcomponent/DashboradHeader';
import StatCard from './dashboardcomponent/Statcard';
import TripCard from './dashboardcomponent/TripCard';
import DocumentCard from './dashboardcomponent/DocumentCard';
import QuickActions from './dashboardcomponent/QuickAtion';
import ActivitySection from './dashboardcomponent/ActivititySection';
import EmergencyContact from './dashboardcomponent/EmergencyContact';
import CalendarSection from './dashboardcomponent/CalenderSection';
import useGlobale from './../components/global';
import menuItems from '../components/UserMenu';


const Dashboard = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const { user } = useGlobale();

    // Configuration du menu

    // Configuration des statistiques
    const stats = [
        {
            title: 'Total Voyages',
            value: '24',
            icon: <Plane className="w-6 h-6" />,
            change: '+12%',
            bgColor: 'from-[#96B734] to-[#437011]'
        },
        {
            title: 'Réservations Actives',
            value: '3',
            icon: <CalendarCheck className="w-6 h-6" />,
            change: '2 en attente',
            bgColor: 'from-[#FF8A3D] to-[#FF6B00]'
        },
        {
            title: 'Documents Valides',
            value: '5',
            icon: <FileText className="w-6 h-6" />,
            change: '1 à renouveler',
            bgColor: 'from-[#96B734] to-[#437011]'
        },
        {
            title: 'Points Fidélité',
            value: '2850',
            icon: <Shield className="w-6 h-6" />,
            change: '+350 ce mois',
            bgColor: 'from-[#FF8A3D] to-[#FF6B00]'
        }
    ];

    // Configuration des voyages récents
    const recentTrips = [
        {
            id: 1,
            type: 'avion',
            from: 'Niamey',
            to: 'Moscou',
            date: '2024-12-01',
            compagnie: 'Air Moscou',
            flightNo: 'AM123',
            status: 'confirmé'
        },
        {
            id: 2,
            type: 'bus',
            from: 'Niamey',
            to: 'Agadez',
            date: '2024-12-15',
            compagnie: 'Rimbo',
            busNo: 'RB456',
            status: 'en attente'
        }
    ];

    // Configuration des actions rapides
    const quickActions = [
        { icon: <Plane />, label: 'Nouveau Voyage', path: '/procedure' },
        { icon: <Hotel />, label: 'Réserver Hôtel' },
        { icon: <Package />, label: 'Mes Bagages' },
        { icon: <HelpCircle />, label: 'Support' }
    ];

    // Configuration des documents
    const documentAlerts = [
        {
            type: 'Passeport',
            expiration: '2024-12-31',
            status: 'Valide',
            icon: <FileText className="w-4 h-4" />
        },
        {
            type: 'Visa',
            expiration: '2024-06-15',
            status: 'À renouveler',
            icon: <FileText className="w-4 h-4" />
        },
        {
            type: 'Assurance',
            expiration: '2024-09-30',
            status: 'Valide',
            icon: <Shield className="w-4 h-4" />
        }
    ];

    return (
        <div className="flex min-h-screen bg-[#F4F8E9]">
            <Sidebar
                isOpen={isSidebarOpen}
                menuItems={menuItems}
                onClose={() => setIsSidebarOpen(false)}
            />

            <div className="flex-1">
                <DashboardHeader
                    isSidebarOpen={isSidebarOpen}
                    setIsSidebarOpen={setIsSidebarOpen}
                    user={user}
                />

                <main className="max-w-7xl mx-auto px-4 sm:px-6 py-4 sm:py-8 pb-20 lg:pb-8">
                    {/* Welcome Section */}
                    <div className="mb-8">
                        <h1 className="text-2xl font-bold text-[#437011]">
                            Bienvenue, {user.first_name} {user.last_name}👋
                        </h1>
                        <p className="text-gray-600">
                            Voici un aperçu de vos activités de voyage
                        </p>
                    </div>

                    {/* Stats Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-8">
                        {stats.map((stat, index) => (
                            <StatCard key={index} {...stat} />
                        ))}
                    </div>

                    {/* Main Content Grid */}
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
                        <div className="lg:col-span-2 space-y-6">
                            {/* Recent Trips */}
                            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                                <div className="p-6">
                                    <div className="flex items-center justify-between mb-6">
                                        <h2 className="text-xl font-semibold text-[#437011] flex items-center">
                                            <Plane className="w-6 h-6 mr-2" />
                                            Voyages Récents
                                        </h2>
                                        <button className="text-[#96B734] hover:text-[#437011] text-sm font-medium">
                                            Voir tout
                                        </button>
                                    </div>
                                    <div className="space-y-4">
                                        {recentTrips.map((trip) => (
                                            <TripCard key={trip.id} trip={trip} />
                                        ))}
                                    </div>
                                </div>
                            </div>

                            {/* Quick Actions */}
                            <QuickActions actions={quickActions} />
                        </div>

                        {/* Documents Status */}
                        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                            <div className="p-6">
                                <h2 className="text-xl font-semibold text-[#437011] flex items-center mb-6">
                                    <FileText className="w-6 h-6 mr-2" />
                                    Status Documents
                                </h2>
                                <div className="space-y-4">
                                    {documentAlerts.map((doc, index) => (
                                        <DocumentCard key={index} doc={doc} />
                                    ))}
                                </div>
                                <button className="w-full mt-6 p-3 bg-[#F4F8E9] text-[#437011] rounded-lg hover:bg-[#96B734] hover:text-white transition-colors">
                                    Gérer mes documents
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Activity Grid */}
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                        <CalendarSection />
                        <ActivitySection />
                        <EmergencyContact />
                    </div>
                </main>

                <MobileNavigation menuItems={menuItems} />
            </div>
        </div>
    );
};

export default Dashboard;